import { environment } from 'src/environments/environment';
import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

export const EXPERIMENTAL_FEATURES_ENVIRONMENTS = ['qa'];

export const ExperimentalFeaturesGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!EXPERIMENTAL_FEATURES_ENVIRONMENTS.includes(environment.profile)) {
    router.navigate(['/secure/dashboard/landing']);

    return false;
  }
  return true;
};
